import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import circlePlusIco from "assets/img/plus-circle-ico.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import useLookup from 'hooks/useLookup';
import useCampaigns from 'hooks/useCampaigns';
import useCampaignsSummary from 'hooks/useCampaignsSummary';
import ConfirmPopup from 'components/modals/ConfirmPopup';
import Stats from 'components/Stats';
import { BrowserView, MobileView } from 'react-device-detect';
import useToast from 'hooks/useToast';
import { Link } from 'react-router-dom';
import { PAGE_NAV } from 'configs/page';
import { currencyFormatter, numberFormatter } from 'utils/formatter';

const CampaignList = (props) => {
    const { statDates } = useLookup();
    const { dateRangeID, setDateRangeID, deleteCampaign } = useCampaigns();
    const { data: campaignList } = useCampaignsSummary(dateRangeID);
    const toast = useToast();
    const mountedRef = useRef(true);
    const [hoveredId, setHoveredId] = useState(null);
    const [isClicked, setIsClicked] = useState(false);

      const handleHoveredClicked = (id)=>{
        
        setHoveredId(prev=>{
            if(prev != id) {
                return id;
            }
            return null;
        });
        setIsClicked(prev=>!prev);
    }

    useEffect(() => {
        return () => { mountedRef.current = false; };
    }, []);

    const [selectedDate, setSelectedDate] = useState("");
    const [dateSelDropdownOn, setDateSelDropdownOn] = useState(false);

    const updateSelDate = (date, e) => {
        e.preventDefault();
        setDateRangeID(date.ItemID);
        setSelectedDate(date.ItemName);
        setDateSelDropdownOn(false);
        setHoveredId(null);
    };

    useEffect(() => {
        if (!selectedDate && statDates.length > 0) {
            const selDate = statDates.find(dt => dt.ItemID === dateRangeID);
            if (selDate) mountedRef.current && setSelectedDate(selDate.ItemName);
        }
    }, [selectedDate, statDates, dateRangeID]);

    const [delConfirmPopup, setDelConfirmPopup] = useState(false);
    const [selCampaign, setSelCampaign] = useState(null);

    const onDelConfirmPopupClosed = () => {
        setSelCampaign(null);
        setDelConfirmPopup(false);
    };

    const onDelConfirmPopupConfirmed = () => {
        if (deleteCampaign.isLoading) return;
        if (!selCampaign || selCampaign?.CampaignDetail?.CampaignID < 1) return;

        deleteCampaign.mutateAsync(selCampaign.CampaignDetail.CampaignID)
            .then(() => {
                if (mountedRef.current) onDelConfirmPopupClosed();
            })
            .catch(err => toast.error("Failed to remove campaign", err));
    };

    const onDelIconClicked = (camp) => {
        setSelCampaign(camp);
        setDelConfirmPopup(true);
    };

    

    useEffect(() => {
        function handleClickOutside(e) {
            if (hoveredId) {
                setHoveredId(null);
                setIsClicked(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [hoveredId]);


    return (
        <div onClick={() => { setDateSelDropdownOn(false); }}>
            <Stats
                statDates={statDates}
                selectedDate={selectedDate}
                dateSelDropdownOn={dateSelDropdownOn}
                setDateSelDropdownOn={setDateSelDropdownOn}
                updateSelDate={(date, e) => updateSelDate(date, e)}
                traffic={campaignList?.StatsSummaries?.length > 0 ? campaignList.StatsSummaries.reduce((acc, curr) => acc + curr.Stats.Traffic, 0) : 0}
                joins={campaignList?.StatsSummaries?.length > 0 ? campaignList.StatsSummaries.reduce((acc, curr) => acc + curr.Stats.Joins, 0) : 0}
                upgrades={campaignList?.StatsSummaries?.length > 0 ? campaignList.StatsSummaries.reduce((acc, curr) => acc + curr.Stats.Upgrades, 0) : 0}
            />

            <div className={classNames("section", "my-compaign", "card-group")}>
                {/* <div className="section-header"> */}
                    {/* <h3>My campaigns</h3> */}
                    {/* <p className="add-compaign"><Link to={PAGE_NAV.CAMPAIGN_ADD} title="Add campaign"><img src={circlePlusIco} alt="+" /> <span>Add campaign</span></Link></p> */}
                    {/* <p className="add-campaign">
                        <Link to={PAGE_NAV.CAMPAIGN_ADD} title="Add campaign">
                            <span>Add</span>
                        </Link>
                    </p> */}
                {/* </div> */}
                

                <div className={classNames('card', 'campaign')}>
                    <div className='card-header'>
                        <h3>My campaigns</h3>
                        {/* <p className="add-compaign"><Link to={PAGE_NAV.CAMPAIGN_ADD} title="Add campaign"><img src={circlePlusIco} alt="+" /> <span>Add campaign</span></Link></p> */}
                        <p className="add-campaign">
                            <Link to={PAGE_NAV.CAMPAIGN_ADD} title="Add campaign">
                                <span>Add</span>
                            </Link>
                        </p>
                    </div>
                    <div className='card-content'>
                                        {/* <BrowserView> */}
                    <table className="compaign-table">
                        <thead className={classNames("thead")}>
                            <tr>
                                <th>Name</th>
                                <th>Joins</th>
                                <th>Sales</th>
                                <th>Earnings</th>
                                <th className='del'> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                campaignList?.StatsSummaries?.length > 0
                                && [...campaignList.StatsSummaries]
                                    .map(c => ({
                                        ...c,
                                        CampaignDetail: {
                                            ...c.CampaignDetail,
                                            Title: c.CampaignDetail.Title || 'Campaign',
                                        }
                                    }))
                                    .sort((a, b) => a.CampaignDetail.Title.toLowerCase() > b.CampaignDetail.Title.toLowerCase() ? 1 : -1)
                                    .map((campaign, i) => {
                                        const rowid= `campaign_${campaign.CampaignDetail.CampaignID}_${selectedDate}_${i}`;
                                        return (
                                        <tr key={rowid}>
                                            <td><Link to={`${PAGE_NAV.CAMPAIGNS}/${campaign.CampaignDetail.CampaignID}`}>{campaign.CampaignDetail.Title}</Link></td>
                                            <td>
                                                {campaign.Stats.Joins > 0 ? numberFormatter.format(campaign.Stats.Joins) : '-'} 
                                                {/* {campaign.Stats.Traffic > 0 && campaign.Stats.Joins > 0 ? `(${Math.round(campaign.Stats.Joins * 100 / campaign.Stats.Traffic)}%)` : ``} */}
                                            </td>
                                            <td>
                                                {campaign.Stats.Upgrades > 0 ? numberFormatter.format(campaign.Stats.Upgrades) : '-'} 
                                                {/* {campaign.Stats.Upgrades > 0 && campaign.Stats.Joins > 0 ? `(${Math.round(campaign.Stats.Upgrades * 100 / campaign.Stats.Joins)}%)` : ``} */}
                                            </td>
                                            <td className='tooltip'>
                                                <span translate="no" className="notranslate"
                                                    onClick={()=>{  if(campaign.Stats.Revenue > 0){ handleHoveredClicked(rowid)}}}
                                                    onMouseEnter={() => { if(campaign.Stats.Revenue > 0) { setHoveredId(rowid);}}}
                                                    onMouseLeave={() => { if(campaign.Stats.Revenue > 0 && !isClicked){setHoveredId(null)}}}
                                                >
                                                        {campaign.Stats.Revenue > 0 ? currencyFormatter.format(campaign.Stats.Revenue) : '-'}
                                                </span>
                                                {   hoveredId==rowid 
                                                    && 
                                                    <em className='tooltip-bubble'>
                                                        <span className='title'>Earnings breakdown</span>
                                                        <span>Commission: <span translate="no" className="notranslate">{currencyFormatter.format(campaign.Stats.Revenue - (campaign.Stats.RevenueQL??0))}</span></span>
                                                        {
                                                            (!!campaign.Stats.RevenueQL && campaign.Stats.RevenueQL > 0) &&
                                                            <span className='ql'><span>Bonus:</span> <span translate="no" className={classNames("notranslate", {"dash":!campaign.RevenueQL || campaign.RevenueQL < 1})}>{(campaign.Stats.RevenueQL && campaign.Stats.RevenueQL > 0) ? currencyFormatter.format(campaign.Stats.RevenueQL) : '-'}</span></span>
                                                        }
                                                    </em>
                                                }
                                            </td>
                                            <td className='del' onClick={(e) => { e.preventDefault(); onDelIconClicked(campaign); }}><FontAwesomeIcon icon={faTrashAlt} /></td>
                                        </tr>
                                    )})
                            }
                        </tbody>
                    </table>
                {/* </BrowserView> */}

                {/* <MobileView>
                    {
                        campaignList?.StatsSummaries?.length > 0
                        && [...campaignList.StatsSummaries]
                            .map(c => ({
                                ...c,
                                CampaignDetail: {
                                    ...c.CampaignDetail,
                                    Title: c.CampaignDetail.Title || 'Campaign',
                                }
                            }))
                            .sort((a, b) => a.CampaignDetail.Title.toLowerCase() > b.CampaignDetail.Title.toLowerCase() ? 1 : -1)
                            .map((campaign, i) => (
                                <div className="table" key={`campaign_${campaign.CampaignDetail.CampaignID}_${i}`}>
                                    <div className="row-header"><Link to={`${PAGE_NAV.CAMPAIGNS}/${campaign.CampaignDetail.CampaignID}`}>{campaign.CampaignDetail.Title}</Link> <FontAwesomeIcon icon={faTrashAlt} onClick={(e) => { e.preventDefault(); onDelIconClicked(campaign); }} /></div>
                                    <div className="th-td">
                                        <div>
                                            <div className="th">Join</div>
                                            <div className="th">Sales</div>
                                            <div className="th">Earnings</div>
                                        </div>
                                        <div>
                                            <div className="td">{numberFormatter.format(campaign.Stats.Joins)} {campaign.Stats.Traffic > 0 && campaign.Stats.Joins > 0 ? `(${Math.round(campaign.Stats.Joins * 100 / campaign.Stats.Traffic)}%)` : ``}</div>
                                            <div className="td">{numberFormatter.format(campaign.Stats.Upgrades)} {campaign.Stats.Upgrades > 0 && campaign.Stats.Joins > 0 ? `(${Math.round(campaign.Stats.Upgrades * 100 / campaign.Stats.Joins)}%)` : ``}</div>
                                            <div className="td">{currencyFormatter.format(campaign.Stats.Revenue)}</div>
                                        </div>
                                    </div>
                                </div>
                            ))
                    }
                </MobileView> */}

                    </div>

                </div>
                



                <ConfirmPopup
                    open={delConfirmPopup}
                    close={onDelConfirmPopupClosed}
                    confirm={onDelConfirmPopupConfirmed}
                    heading="Delete campaign"
                    btnText="Delete campaign">
                    <p>Are you sure you want to delete this campaign : {selCampaign?.CampaignDetail?.Title}?</p>
                </ConfirmPopup>
            </div>
        </div>
    );
};

export default CampaignList;
